import _extends from "@babel/runtime/helpers/extends";
import { Fragment } from "react";
import { useBanner } from "../../../contexts";
import { Checkbox } from "../..";
import { useGroupCheckbox } from "../../../hooks";
const BannerDottedGroup = _ref => {
  let {
    group
  } = _ref;
  const {
    name
  } = group;
  const banner = useBanner();
  const {
    decision: {
      groupsFirstView
    },
    design: {
      fontSize
    }
  } = banner;
  const isPro = process.env.PLUGIN_CTX === "pro";
  const showCheckbox = isPro && groupsFirstView;
  const groupCheckbox = useGroupCheckbox(group);
  return h(Fragment, null, showCheckbox ? h(Checkbox, _extends({}, groupCheckbox, {
    fontSize: fontSize
  }), name) : h("span", null, h("i", null), h("span", null, name)));
};
export { BannerDottedGroup };